
const LandingHeroHeading = ({ children, additionalclasses }) => {
    return (
        <p className={`font-jakarta text-[36px] lg:text-[72px] leading-[44px] lg:leading-[90px] font-semibold tracking-[-0.72px] lg:tracking-[-1.44px] text-white text-center ${additionalclasses}`}>
            {children}
        </p>
    );
};

export default LandingHeroHeading;